import * as actionTypes from "../actionTypes/Index";

import {Dispatch} from "react";
import {
    IActionType, ICreateUpdateStaffRequestPayload, ICreateWarehouseStaffUserRequestPayload,
    IGetQueryParams, IMultiSelectDropdownPayload,
    IUserDetailsResponseObject,
    IWarehousePayload,
    IWarehouseStaffListingResponse
} from "../../interfaces/Index";
import userSource, {UserAddUpdateDto} from "../sources/UserSource";
import {
    createStaffApi,
    fetchWarehouseStaffListingApi,
    getAllJobTypesApi,
    getAllWarehousesApi,
    getWarehouseStaffUserDetailsApi,
    staffFrom,
    updateStaffApi,
    userFrom
} from "../sources/WarehouseStaffSource";

export const fetchWarehouseStaffListingInit = () => ({
    type: actionTypes.WAREHOUSE_STAFF_LISTING_INIT,
});

export const fetchWarehouseStaffListingSuccess = (payload: IWarehouseStaffListingResponse[]) => ({
    type: actionTypes.WAREHOUSE_STAFF_LISTING_SUCCESS,
    payload,
});

export const fetchWarehouseStaffListingFailed = (error: string | object | null) => ({
    type: actionTypes.WAREHOUSE_STAFF_LISTING_FAIL,
    error,
});

export const getWarehouseStaffUserDetailsInit = () => ({
    type: actionTypes.GET_WAREHOUSE_STAFF_USER_DETAILS_INIT,
});

export const getWarehouseStaffUserDetailsSuccess = (payload: IUserDetailsResponseObject) => ({
    type: actionTypes.GET_WAREHOUSE_STAFF_USER_DETAILS_SUCCESS,
    payload,
});

export const getWarehouseStaffUserDetailsFailed = (error: string | object | null) => ({
    type: actionTypes.GET_WAREHOUSE_STAFF_USER_DETAILS_FAIL,
    error,
});

export const getAllJobTypesInit = () => ({
    type: actionTypes.GET_ALL_JOB_TYPES_INIT,
});

export const getAllJobTypesSuccess = (payload: IMultiSelectDropdownPayload[]) => ({
    type: actionTypes.GET_ALL_JOB_TYPES_SUCCESS,
    payload
});

export const getAllJobTypesFailed = (
    error: string | object | null
) => ({
    type: actionTypes.GET_ALL_JOB_TYPES_FAIL,
    error,
});

export const createStaffInit = () => ({
    type: actionTypes.CREATE_STAFF_INIT,
});

export const createStaffSuccess = () => ({
    type: actionTypes.CREATE_STAFF_SUCCESS,
});

export const createStaffFailed = (
    error: string | object | null
) => ({
    type: actionTypes.CREATE_STAFF_FAIL,
    error,
});

export const getAllWarehousesInit = () => ({
    type: actionTypes.GET_ALL_WAREHOUSES_INIT,
});

export const getAllWarehousesSuccess = (payload: IWarehousePayload[]) => ({
    type: actionTypes.GET_ALL_WAREHOUSES_SUCCESS,
    payload
});

export const getAllWarehousesFailed = (
    error: string | object | null
) => ({
    type: actionTypes.GET_ALL_WAREHOUSES_FAIL,
    error,
});

export const updateStaffInit = () => ({
    type: actionTypes.UPDATE_STAFF_INIT,
});

export const updateStaffSuccess = () => ({
    type: actionTypes.UPDATE_STAFF_SUCCESS,
});

export const updateStaffFailed = (
    error: string | object | null
) => ({
    type: actionTypes.UPDATE_STAFF_FAIL,
    error,
});

// async actions
export const fetchWarehouseStaffListing = (queryParams?: IGetQueryParams) =>
    (dispatch: Dispatch<IActionType>) => {
        dispatch(fetchWarehouseStaffListingInit());
        return fetchWarehouseStaffListingApi(queryParams)
            .then((payload: IWarehouseStaffListingResponse[]) =>
                dispatch(fetchWarehouseStaffListingSuccess(payload))
            )
            .catch((e: object | null | string) => dispatch(fetchWarehouseStaffListingFailed(e)));
};


export const getWarehouseStaffUserDetails = (userId: string) =>
        (dispatch: Dispatch<IActionType>) => {
            dispatch(getWarehouseStaffUserDetailsInit());
            return getWarehouseStaffUserDetailsApi(userId)
                .then((payload: IUserDetailsResponseObject) =>
                    dispatch(getWarehouseStaffUserDetailsSuccess(payload))
                )
                .catch((e: object | null | string) => dispatch(getWarehouseStaffUserDetailsFailed(e)));
        };

export const getAllWarehouses = () =>
    (dispatch: Dispatch<IActionType>) => {
        dispatch(getAllWarehousesInit());
        return getAllWarehousesApi()
            .then((payload: IWarehousePayload[]) =>
                dispatch(getAllWarehousesSuccess(payload))
            )
            .catch((e: object | null | string) => dispatch(getAllWarehousesFailed(e)));
    };

export const getAllJobTypes = () =>
    (dispatch: Dispatch<IActionType>) => {
        dispatch(getAllJobTypesInit());
        return getAllJobTypesApi()
            .then((payload: IMultiSelectDropdownPayload[]) =>
                dispatch(getAllJobTypesSuccess(payload))
            )
            .catch((e: object | null | string) => dispatch(getAllJobTypesFailed(e)));
    };


export const createStaff = (payload: ICreateUpdateStaffRequestPayload) =>
    (dispatch: Dispatch<IActionType>) => {
        dispatch(createStaffInit());
        return createStaffApi(payload)
            .then(() => dispatch(createStaffSuccess()))
            .catch((e: object | null | string) => dispatch(createStaffFailed(e)));
};

export const createStaffWithUser = (payload: ICreateWarehouseStaffUserRequestPayload) =>
    (dispatch: Dispatch<IActionType>) => {
        dispatch(createStaffInit());
        const createWarehouseStaffUserPayload = userFrom(payload, payload.id);
        return userSource
            .createUser(UserAddUpdateDto.fromCreateDto(null, createWarehouseStaffUserPayload))
            .then((response) => {
                const staffPayload = staffFrom(payload, response.id);

                return createStaffApi(staffPayload);
            })
            .then(() => dispatch(createStaffSuccess()))
            .catch((e: object | null | string) =>
                dispatch(createStaffFailed(e))
            );
    }

export const updateStaffWithUser = (
    payload: ICreateWarehouseStaffUserRequestPayload
) => (dispatch: Dispatch<IActionType>) => {
    dispatch(updateStaffInit());
    const updateUserPayload = userFrom(payload, payload.id)

    return userSource
        .updateUser(
            payload.userId as string,
            UserAddUpdateDto.fromUpdateDto(payload.userId as string, updateUserPayload)
        )
        .then(() => {
            return updateStaffApi(payload);
        })
        .then(() => dispatch(updateStaffSuccess()))
        .catch((e: object | null | string) =>
            dispatch(updateStaffFailed(e))
        );
};